"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Scale, Sparkles } from "lucide-react";

export function Header() {
  return (
    <header className="border-b bg-white/80 backdrop-blur-lg sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link href="/" className="flex items-center gap-3 group">
          <div className="p-2 bg-brand-gradient rounded-xl group-hover:scale-110 transition-transform duration-300">
            <Scale className="h-6 w-6 text-white" />
          </div>
          <div>
            <span className="text-2xl font-bold heading-gradient">
              Litiverse
            </span>
            <div className="flex items-center gap-1 -mt-1">
              <Sparkles className="h-3 w-3 text-blue-600" />
              <span className="text-xs text-gray-500 font-medium tracking-wide">
                POWERED BY AI
              </span>
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center space-x-8">
          <Link
            href="/profiles"
            className="text-gray-600 hover:text-blue-600 font-medium transition-colors duration-200 relative group"
          >
            Profiles
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link
            href="/news"
            className="text-gray-600 hover:text-blue-600 font-medium transition-colors duration-200 relative group"
          >
            News
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
          </Link>
          <Link
            href="/about"
            className="text-gray-600 hover:text-blue-600 font-medium transition-colors duration-200 relative group"
          >
            About
            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
          </Link>
        </nav>

        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            asChild
            className="interactive-button font-semibold"
          >
            <Link href="/login">Login</Link>
          </Button>
          <Button
            asChild
            className="interactive-button bg-brand-gradient border-0 text-white font-semibold rounded-xl"
          >
            <Link href="/signup">Sign Up</Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
